import { Compass, Monitor, Search, Megaphone, Workflow, LifeBuoy } from "lucide-react"

// Maps the `icon` names in data/services.js to lucide components.
export const SERVICE_ICONS = { Compass, Monitor, Search, Megaphone, Workflow, LifeBuoy }
